import type { TypographyVariants } from 'fitify-ui/src/typography/generated/Typography.Types'
import type { AnchorHTMLAttributes } from 'react'

import { StyledLink } from './Link.Styled'

type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  $variant: TypographyVariants
}

export const Link = ({ children, $variant, ...htmlProps }: LinkProps) => {
  return (
    <StyledLink $variant={$variant} {...htmlProps}>
      {children}
    </StyledLink>
  )
}
